import "@/App.css";
import "@/index.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Components
import ScrollToTop from "@/components/ui/ScrollToTop";

// Chatbot
import SquareTriggerChatbot from "@/chatbot/SquareTriggerChatbot";

// Pages
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import ContactPage from "@/pages/ContactPage";
import GetStartedPage from "@/pages/GetStartedPage";
import SolutionsPage from "@/pages/SolutionsPage";

// Service Pages
import WebsiteDevelopmentPage from "@/pages/services/WebsiteDevelopmentPage";
import ServicePage from "@/pages/services/ServicePage";
import SeoServicesPage from "@/pages/services/SeoServicesPage";
import SocialMediaMarketingPage from "@/pages/services/SocialMediaMarketingPage";
// import UiUxDesignPage from "@/pages/services/UiUxDesignPage";
import MaintenanceSupportPage from "@/pages/services/MaintenanceSupportPage";
// import EcommerceSolutionsPage from "@/pages/services/EcommerceSolutionsPage";

// Portfolio Pages
import CaseStudiesPage from "@/pages/portfolio/CaseStudiesPage";
import GalleryPage from "@/pages/portfolio/GalleryPage";
import TestimonialsPage from "@/pages/portfolio/TestimonialsPage";

// Company Pages
import AboutPage from "@/pages/company/AboutPage";
import ProcessPage from "@/pages/company/ProcessPage";
import ValuesPage from "@/pages/company/ValuesPage";
import CareersPage from "@/pages/company/CareersPage";

// Resources Pages
import FAQsPage from "@/pages/resources/FAQsPage";
import FreeResourcesPage from "@/pages/resources/FreeResourcesPage";
import NewsPage from "@/pages/resources/NewsPage";

function App() {
  const location = useLocation();

  const noIndexRoutes = [];

  const shouldNoIndex = noIndexRoutes.some(
    (p) => location.pathname === p || location.pathname === `${p}/`
  );

  return (
    <>
      {/* Global Robots Tag */}
      <Helmet>
        <meta
          name="robots"
          content={shouldNoIndex ? "noindex, nofollow" : "index, follow"}
        />
      </Helmet>

      {/* Scroll Logic */}
      <ScrollToTop />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<HomePage />} />

        {/* Blog - new + old paths both supported */}
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:id" element={<BlogPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogPage />} />

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/services" element={<SolutionsPage />} />

        {/* Service Pages */}
        <Route
          path="/services/website-development"
          element={<WebsiteDevelopmentPage />}
        />
        <Route path="/services/:serviceSlug" element={<ServicePage />} />
        <Route path="/services/seo-services" element={<SeoServicesPage />} />
        <Route
          path="/services/social-media-marketing"
          element={<SocialMediaMarketingPage />}
        />
        {/* <Route path="/services/ui-ux-design" element={<UiUxDesignPage />} /> */}
        <Route
          path="/services/maintenance-support"
          element={<MaintenanceSupportPage />}
        />
        {/* <Route
          path="/services/e-commerce-solutions"
          element={<EcommerceSolutionsPage />}
        /> */}

        {/* Portfolio Pages */}
        <Route path="/portfolio/case-studies" element={<CaseStudiesPage />} />
        <Route path="/portfolio/gallery" element={<GalleryPage />} />
        <Route
          path="/portfolio/testimonials"
          element={<TestimonialsPage />}
        />

        {/* Company Pages - new + old paths both supported */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/company/about" element={<AboutPage />} />
        <Route path="/company/process" element={<ProcessPage />} />
        <Route path="/company/values" element={<ValuesPage />} />
        <Route path="/company/careers" element={<CareersPage />} />

        {/* Resources Pages - new + old paths both supported */}
        <Route path="/resources-faqs" element={<FAQsPage />} />
        <Route path="/resources/faqs" element={<FAQsPage />} />
        <Route path="/resources/free" element={<FreeResourcesPage />} />
        <Route path="/resources/news" element={<NewsPage />} />

        {/* Fallback */}
        <Route path="*" element={<HomePage />} />
      </Routes>

      {/* Chatbot overlay on all pages */}
      {/* <SquareTriggerChatbot /> */}
    </>
  );
}

export default App;